import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiUsersService } from '../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-user-add-experience-modal',
  templateUrl: './user-add-experience-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class UserAddExperienceModalComponent {

  @Input() userId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  experienceQuantity: number | null = null;

  private callbackSaved?: () => void;

  constructor(private apiUsersService: ApiUsersService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.experienceQuantity = null;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiUsersService.addLevelExperience(this.userId, this.experienceQuantity ?? 0).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Experience added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding experience : ' + error);
      }
    );
  }
}
